/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WebsiteHttpHeadersQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type WebsiteHttpHeadersQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly httpHeaders: ReadonlyArray<{ readonly __typename?: 'WebsiteFetchingSettingsHttpHeader', readonly name: string, readonly value: string }> } | null };


export const WebsiteHttpHeadersDocument = gql`
    query WebsiteHttpHeaders($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    httpHeaders {
      name
      value
    }
    id
  }
}
    `;

/**
 * __useWebsiteHttpHeadersQuery__
 *
 * To run a query within a React component, call `useWebsiteHttpHeadersQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteHttpHeadersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteHttpHeadersQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useWebsiteHttpHeadersQuery(baseOptions: Apollo.QueryHookOptions<WebsiteHttpHeadersQuery, WebsiteHttpHeadersQueryVariables> & ({ variables: WebsiteHttpHeadersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteHttpHeadersQuery, WebsiteHttpHeadersQueryVariables>(WebsiteHttpHeadersDocument, options);
      }
export function useWebsiteHttpHeadersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteHttpHeadersQuery, WebsiteHttpHeadersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteHttpHeadersQuery, WebsiteHttpHeadersQueryVariables>(WebsiteHttpHeadersDocument, options);
        }
export function useWebsiteHttpHeadersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteHttpHeadersQuery, WebsiteHttpHeadersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteHttpHeadersQuery, WebsiteHttpHeadersQueryVariables>(WebsiteHttpHeadersDocument, options);
        }
export type WebsiteHttpHeadersQueryHookResult = ReturnType<typeof useWebsiteHttpHeadersQuery>;
export type WebsiteHttpHeadersLazyQueryHookResult = ReturnType<typeof useWebsiteHttpHeadersLazyQuery>;
export type WebsiteHttpHeadersSuspenseQueryHookResult = ReturnType<typeof useWebsiteHttpHeadersSuspenseQuery>;
export type WebsiteHttpHeadersQueryResult = Apollo.QueryResult<WebsiteHttpHeadersQuery, WebsiteHttpHeadersQueryVariables>;